export function fbqTrack(key: string, data?: any) {
  try {
    if ((window as any).fbq) {
      ;(window as any).fbq('track', key, data)
    }
  } catch (err) {
    console.error(err)
  }
}
